export default __webpack_public_path__ + "static/media/person.8417d725.svg";